import {useSuspenseQuery} from "@tanstack/react-query";
import axios from "axios";
import React from "react";
import {useParams} from "react-router-dom";
import {useGoogleMaps} from "../hooks/useGoogleMaps";
import {StopStatus, getOrdererRideInfo, OrdererTrackingPageParams} from "../model/rideInfo";
import {DeliveryInfoPanel} from "./DeliveryInfoPanel";
import {Map} from "./Map";
import {getMapClass} from "./RecipientTrackingPage";

const inProgressStatuses: (StopStatus | undefined)[] = [
    "IN_QUEUE",
    "DELIVERING",
    "ARRIVED",
    "UNDELIVERED",
    "REDIRECTED",
];

export function OrdererTrackingPage() {
    const {shareKey} = useParams<OrdererTrackingPageParams>();
    const {data: ride} = useSuspenseQuery({
        queryKey: ["delivery-ride"],
        queryFn: () => getOrdererRideInfo(shareKey),
        refetchInterval: (query) =>
            query?.state.data &&
            query.state.data.stops.filter((stop) =>
                inProgressStatuses.includes(stop.details?.status)
            ).length === 0
                ? 0
                : 5000,
        retry: (failureCount, error) => {
            if (axios.isAxiosError(error) && error.response?.status === 404) {
                return false;
            }
            return failureCount < 3;
        },
    });
    const mapLoaded = useGoogleMaps();

    const hasFinished =
        ride.stops.filter((stop) => inProgressStatuses.includes(stop.details?.status)).length === 0;

    return (
        <div className="map-page">
            <div className="map-page-content">
                {mapLoaded ? (
                    <Map
                        deliveryStops={ride.stops
                            .filter((stop) => stop.details)
                            .map((stop) => stop.destinationLocation)}
                        driver={ride.driverPosition}
                        carColor={ride.carInfo?.color}
                        route={ride.route}
                        inQueue={ride.stops[0].details?.status === "IN_QUEUE"} //undefined in case of first stop without details, inQueue message not needed that much
                        wrapperClassName={getMapClass(hasFinished)}
                    />
                ) : (
                    <div className={getMapClass(hasFinished)}></div>
                )}
                <DeliveryInfoPanel ride={ride} hasFinished={hasFinished} />
            </div>
        </div>
    );
}
